var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"embed-emplacamento"}},[_c('b-overlay',{attrs:{"id":"overlay-background","show":_vm.overlayShow,"variant":_vm.variant,"opacity":_vm.opacity,"blur":_vm.blur}},[_c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"100vh","frameborder":"0"},on:{"load":_vm.disabledLoading}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }